import React from 'react';
import s from './faq.module.scss';
import locales from '../../../content.json';

export const FaqV2 = ({theme1}) => {
  const [activeIndexes, setActiveIndexes] = React.useState([0]);
  const faqData = [
    {
      question: locales[window.userLang].chatUpsaleV2_28,
      answer: locales[window.userLang].chatUpsaleV2_29,
    },
    {
      question: locales[window.userLang].chatUpsaleV2_30,
      answer: locales[window.userLang].chatUpsaleV2_31,
    },
    {
      question: locales[window.userLang].chatUpsaleV2_32,
      answer: locales[window.userLang].chatUpsaleV2_33,
    },
  ];
  return (
    <div className={`${s.faqWrapper} ${theme1 ? s.theme1 : ''}`}>
      <p className={s.faqTitle}>{locales[window.userLang].payment_text_201}</p>
      <div className={s.faqItems}>
        {faqData.map((item, idx) => (
          <div
            key={idx}
            className={activeIndexes.includes(idx) ? `${s.faqItem} ${s.active}` : s.faqItem}
          >
            <p
              className={s.faqItemQuestion}
              onClick={() => setActiveIndexes(
                activeIndexes.includes(idx)
                  ? activeIndexes.filter(i => i !== idx)
                  : [...activeIndexes, idx]
              )}
            >
              {item.question}
            </p>
            <p className={s.faqItemAnswer}>{item.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}